import { Alert, AlertTitle, Container, MenuItem, Select, Stack } from '@customink/pigment-react';
import { PageHeader } from '~/components/PageHeader/PageHeader';
import { useOptimizelyQueryParam } from '~/pages/Flags/UseOptimizelyQueryParam';
import { OptimizelyProject } from '~/adapters/optimizely/optimizelyProjects';
import { useHistory } from 'react-router-dom';
import { FlagsTable } from '~/pages/Flags/FlagsTable';
import { FeatureFlagsProjectContext } from '~/pages/Flags/FeatureFlagsProjectContext';
import { ErrorBoundary } from '~/components/ErrorBoundary';

export function Flags() {
    const projectName = useOptimizelyQueryParam();
    const history = useHistory();

    return (
        <Container maxWidth="xl">
            <Stack direction="row" alignItems="flex-start" justifyContent="space-between">
                <PageHeader>Feature Flags</PageHeader>
                <Select
                    sx={{ minWidth: '180px' }}
                    value={projectName}
                    onChange={(e) => {
                        history.replace(`/flags?project=${e.target.value}`);
                    }}
                >
                    {Object.values(OptimizelyProject).map((project) => (
                        <MenuItem key={project} value={project}>
                            {project.toUpperCase()}
                        </MenuItem>
                    ))}
                </Select>
            </Stack>

            <Alert severity="warning" sx={{ mb: 4 }}>
                <AlertTitle>WARNING: EXPERIMENTAL FEATURES AHEAD</AlertTitle>
                By changing these settings, you may get unfinished user experiences, encounter bugs or lose some
                functionalities. Following options are for testing purposes only.
            </Alert>

            <ErrorBoundary errorMessage="An error occurred while retrieving your feature flags">
                <FeatureFlagsProjectContext>
                    <FlagsTable />
                </FeatureFlagsProjectContext>
            </ErrorBoundary>
        </Container>
    );
}
